"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_verification_code_input_1 = __importDefault(require("react-verification-code-input"));
var styles_1 = require("../../styles");
var ReactCodeInputComponent = react_verification_code_input_1.default;
exports.CodeInput = function (_a) {
    var _b, _c;
    var value = _a.value, onChange = _a.onChange, length = _a.length, restProps = __rest(_a, ["value", "onChange", "length"]);
    return (React.createElement(StyledCodeInput, __assign({ type: 'number', fields: length, values: (_c = (_b = value) === null || _b === void 0 ? void 0 : _b.toString()) === null || _c === void 0 ? void 0 : _c.split(''), onChange: function (value) {
            if (!!onChange)
                onChange(value);
        }, fieldWidth: 32, fieldHeight: 32 }, restProps)));
};
var StyledCodeInput = styled_1.default(ReactCodeInputComponent)({
    width: 'fit-content !important',
    '& div': {
        width: '100%'
    },
    '& input': __assign(__assign({ outline: 'none', width: 32, ':first-child, :last-child': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: "1px solid " + styles_1.palette['stone-lighter-20'],
            borderRadius: 0
        }, ':not(:first-of-type)': {
            marginLeft: 8
        }, ':focus': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderBottom: "1px solid " + styles_1.palette['black-base'],
            caretColor: 'transparent'
        }, padding: '8px 0', textAlign: 'center', borderTop: 'none', borderLeft: 'none', borderRight: 'none', borderBottom: "1px solid " + styles_1.palette['stone-lighter-20'] }, styles_1.subheadLight[1]), { backgroundColor: 'transparent' })
});
//# sourceMappingURL=CodeInput.js.map